"use client"

import { useCallback } from "react"
import { useProductPurchase } from "../context/product-purchase-context"
import { PRODUCT_COPY } from "../lib/product-copy"

const focusPurchasePanel = (purchasePanelId: string) => {
  const panel = document.getElementById(purchasePanelId)
  if (!panel) return
  panel.scrollIntoView({ behavior: "smooth", block: "center" })
  const target = panel.querySelector<HTMLElement>(
    '[aria-invalid="true"]:not(:disabled), input[name="purchase-choice"]:not(:disabled), [data-testid="option-button"]:not(:disabled)'
  )
  ;(target ?? panel).focus({ preventScroll: true })
}

export function useProductPurchaseIntent(purchasePanelId: string) {
  const purchase = useProductPurchase()
  const incomplete = !purchase.availability.complete
  const unavailable =
    purchase.availability.complete &&
    (!purchase.availability.available || !purchase.canPurchase)
  const adding = purchase.status === "adding"
  const disabled = adding || unavailable
  const primaryLabel = adding
    ? "Ekleniyor…"
    : incomplete
      ? PRODUCT_COPY.selectOptions
      : unavailable
        ? PRODUCT_COPY.soldOut
        : PRODUCT_COPY.addToCart

  const run = useCallback(() => {
    if (adding || unavailable) return
    if (incomplete) {
      focusPurchasePanel(purchasePanelId)
      return
    }
    if (purchase.canPurchase) void purchase.addCurrentSelection()
  }, [adding, incomplete, purchase, purchasePanelId, unavailable])

  return { incomplete, unavailable, disabled, primaryLabel, run }
}
